export const dpp_format = [
  // Digital Access
  {
    field: "id",
    type: "string",
    label: "ID",
    default: "",
    disabled: true,
    section: "Digital Access",
  },

  // Product Identity
  {
    field: "product_id",
    type: "string",
    label: "Product ID",
    default: "",
    section: "Product Identity",
  },
  {
    field: "product_name",
    type: "string",
    label: "Product Name",
    default: "x",
    section: "Product Identity",
  },
  {
    field: "brand",
    type: "string",
    label: "Brand",
    default: "x",
    section: "Product Identity",
  },
  {
    field: "sub_category",
    type: "string",
    label: "Sub Category",
    default: "",
    section: "Product Identity",
  },
  {
    field: "place_of_manufacture",
    type: "string",
    label: "Place Of Manufacture",
    default: "",
    section: "Product Identity",
  },
  {
    field: "model_number",
    type: "string",
    label: "Model Number",
    default: "",
    section: "Product Identity",
  },
  {
    field: "gtin",
    type: "string",
    label: "GTIN",
    default: "",
    section: "Product Identity",
  },
  {
    field: "batch_number",
    type: "string",
    label: "Batch Number",
    default: "",
    section: "Product Identity",
  },
  {
    field: "place_of_use",
    type: "string",
    label: "Place Of Use",
    default: "",
    section: "Product Identity",
  },
  {
    field: "production_date",
    type: "string",
    label: "Production Date",
    default: "",
    section: "Product Identity",
  },
  {
    field: "country_of_origin",
    type: "string",
    label: "Country Of Origin",
    default: "",
    section: "Product Identity",
  },
  {
    field: "product_category",
    type: "string",
    label: "Product Category",
    default: "",
    section: "Product Identity",
  },

  // Manufacturer Identity
  {
    field: "manufacturer_name",
    type: "string",
    label: "Manufacturer Name",
    default: "x",
    section: "Manufacturer Identity",
  },
  {
    field: "manufacturer_address",
    type: "string",
    label: "Manufacturer Address",
    default: "",
    section: "Manufacturer Identity",
  },
  {
    field: "manufacturer_email",
    type: "string",
    label: "Manufacturer Email",
    default: "",
    section: "Manufacturer Identity",
  },
  {
    field: "manufacturer_website",
    type: "string",
    label: "Manufacturer Website",
    default: "",
    section: "Manufacturer Identity",
  },
  {
    field: "manufacturer_phone",
    type: "string",
    label: "Manufacturer Phone",
    default: "",
    section: "Manufacturer Identity",
  },
  {
    field: "manufacturer_contact_person",
    type: "string",
    label: "Manufacturer Contact Person",
    default: "",
    section: "Manufacturer Identity",
  },

  // Compliance
  {
    field: "compliance_ce",
    type: "boolean",
    label: "Compliance CE",
    default: true,
    section: "Compliance",
  },
  {
    field: "compliance_rohs",
    type: "boolean",
    label: "Compliance ROHS",
    default: false,
    section: "Compliance",
  },
  {
    field: "compliance_reach",
    type: "boolean",
    label: "Compliance REACH",
    default: false,
    section: "Compliance",
  },
  {
    field: "compliance_weee",
    type: "boolean",
    label: "Compliance WEEE",
    default: false,
    section: "Compliance",
  },
  {
    field: "compliance_ecodesign",
    type: "string",
    label: "Compliance EcoDesign",
    default: "",
    section: "Compliance",
  },
  {
    field: "digital_twin_format",
    type: "string",
    label: "Digital Twin Format",
    default: "",
    section: "Compliance",
  },

  // Material Composition
  {
    field: "materials",
    type: "list",
    label: "Materials",
    section: "Material Composition",
    default: [
      {
        type: "",
        category: "",
        description: "",
        quantity: 0,
        unit: "",
        gwp: 0,
        biogenic_gwp: 0,
        recycledContentPercent: 0,
      },
    ],
    itemDef: [
      { field: "type", label: "Type", type: "string", default: "" },
      { field: "category", label: "Category", type: "string", default: "" },
      { field: "description", label: "Description", type: "string", default: "" },
      { field: "quantity", label: "Quantity", type: "float", default: 0 },
      {
        field: "material_composition_percentage",
        label: "Material Composition Percentage",
        type: "float",
        default: 0,
        computed: true,
      },
      { field: "unit", label: "Unit", type: "string", default: "" },
      { field: "gwp", label: "GWP", type: "string", default: "" },
      { field: "biogenic_gwp", label: "Biogenic GWP", type: "string", default: "" },
      {
        field: "recycledContentPercent",
        label: "Recycled Content Percent",
        type: "float",
        default: 0,
      },
    ],
  },

  // Environmental Impact
  {
    field: "gwp_total",
    type: "float",
    label: "GWP Total (kgCO2e)",
    default: 0,
    section: "Environmental Impact",
  },
  {
    field: "energy_consumption_value",
    type: "float",
    label: "Energy Consumption (kWh)",
    default: 0,
    section: "Environmental Impact",
  },
  {
    field: "repairability_score",
    type: "float",
    label: "Repairability Score",
    default: 0,
    section: "Environmental Impact",
  },
  {
    field: "service_life",
    type: "float",
    label: "Reference Service Life",
    default: 0,
    section: "Environmental Impact",
  },
  {
    field: "extended_service_life",
    type: "float",
    label: "Extended Service Life",
    default: 0,
    section: "Environmental Impact",
  },
  {
    field: "expected_lifespan_years",
    type: "float",
    label: "Expected Lifespan Years",
    default: 0,
    section: "Environmental Impact",
  },
  // Circularity
  {
    field: "mci",
    type: "float",
    label: "MCI",
    default: 0,
    section: "Circularity",
  },
  {
    field: "recyclability_percent",
    type: "float",
    label: "Recyclability Percent",
    default: 0,
    section: "Circularity",
  },
  {
    field: "recycling_instructions",
    type: "string",
    label: "Recyclability Instructions",
    default: "",
    section: "Circularity",
  },
  {
    field: "renewable_materials_percent",
    type: "float",
    label: "Renewable Materials Percent",
    default: 0,
    section: "Circularity",
  },
  {
    field: "take_back_available",
    type: "boolean",
    label: "Take Back Available",
    default: false,
    section: "Circularity",
  },
  {
    field: "take_back_details",
    type: "string",
    label: "Take Back Details",
    default: "",
    section: "Circularity",
  },
  {
    field: "interoperability_standard",
    type: "string",
    label: "Interoperability Standard",
    default: "",
    section: "Circularity",
  },

  // Certificates
  {
    field: "certifications",
    type: "list",
    label: "Certifications",
    section: "Certificates",
    default: [
      {
        name: "",
        certificationBody: "",
        certificateNumber: "",
        issueDate: "1970-01-01",
        validUntil: "1970-01-01",
        url: "",
      },
    ],
    itemDef: [
      { field: "name", label: "Name", type: "string", default: "" },
      {
        field: "certificationBody",
        label: "Certification Body",
        type: "string",
        default: "",
      },
      {
        field: "certificateNumber",
        label: "Certificate Number",
        type: "string",
        default: "",
      },
      {
        field: "issueDate",
        label: "Issue Date",
        type: "string",
        default: "1970-01-01",
      },
      {
        field: "validUntil",
        label: "Valid Until",
        type: "string",
        default: "1970-01-01",
      },
      { field: "url", label: "URL", type: "string", default: "" },
    ],
  },

  // Durability, Repair & Circular Design
  {
    field: "repairability_rating",
    type: "string",
    label: "Repairability Score",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "durability_rating",
    type: "string",
    label: "Durability Score",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "design_life_en_1993_1_1",
    type: "string",
    label: "Design Life (EN 1993-1-1)",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "recoat_interval",
    type: "string",
    label: "Recoat Interval",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "corrosion_class_iso_12944",
    type: "string",
    label: "Corrosion Class (ISO 12944)",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "mtbf",
    type: "string",
    label: "MTBF",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "execution_class_en_1090_2",
    type: "string",
    label: "Execution Class (EN 1090-2)",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "target_eol_recycling_rate",
    type: "string",
    label: "Target End-of-Life Recycling Rate",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "repair_maintenance_notes",
    type: "string",
    label: "Repair & Maintenance",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "upgrading_reuse_remanufacture_notes",
    type: "string",
    label: "Upgrading, Reuse, Remanufacture",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "design_for_recycling_notes",
    type: "string",
    label: "Design for Recycling",
    default: "",
    section: "Durability, Repair & Circular Design",
  },
  {
    field: "installation_end_of_life_notes",
    type: "string",
    label: "Installation & End-of-Life",
    default: "",
    section: "Durability, Repair & Circular Design",
  },

  // Functional Performance & Design
  {
    field: "functional_performance_notes",
    type: "string",
    label: "Functional Performance",
    default: "",
    section: "Functional Performance & Design",
  },
  {
    field: "lightweight_design_notes",
    type: "string",
    label: "Lightweight Design",
    default: "",
    section: "Functional Performance & Design",
  },

  // Substances of Concern
  {
    field: "substances_of_concern",
    type: "list",
    label: "Substances of Concern",
    section: "Substances of Concern",
    default: [
      {
        substance_name: "",
        cas_number: "",
        ec_number: "",
        role: "",
        location_in_product: "",
        concentration_percent_w_w: "",
        coating_thickness: "",
        svhc_above_threshold: "",
        safe_use_instructions: "",
        end_of_life_handling: "",
      },
    ],
    itemDef: [
      { field: "substance_name", label: "Substance Name", type: "string", default: "" },
      { field: "cas_number", label: "CAS Number", type: "string", default: "" },
      { field: "ec_number", label: "EC Number", type: "string", default: "" },
      { field: "role", label: "Role", type: "string", default: "" },
      { field: "location_in_product", label: "Location In Product", type: "string", default: "" },
      { field: "concentration_percent_w_w", label: "Concentration (% w/w)", type: "string", default: "" },
      { field: "coating_thickness", label: "Coating Thickness", type: "string", default: "" },
      { field: "svhc_above_threshold", label: "SVHC Above 0.1% w/w", type: "string", default: "" },
      { field: "safe_use_instructions", label: "Safe Use Instructions", type: "string", default: "" },
      { field: "end_of_life_handling", label: "End-of-Life Handling", type: "string", default: "" },
    ],
  },

  // Producer & Facility Identification
  {
    field: "unique_operator_id",
    type: "string",
    label: "Unique Operator ID (UOI)",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "facility_manufacturer",
    type: "string",
    label: "Manufacturer",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "facility_manufacturer_address",
    type: "string",
    label: "Manufacturer Address",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "facility_manufacturer_contact",
    type: "string",
    label: "Manufacturer Contact",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "eu_operator",
    type: "string",
    label: "EU Operator",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "eu_operator_address",
    type: "string",
    label: "EU Operator Address",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "facility_importer",
    type: "string",
    label: "Importer",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "eori",
    type: "string",
    label: "EORI",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "production_facility",
    type: "string",
    label: "Production Facility",
    default: "",
    section: "Producer & Facility Identification",
  },
  {
    field: "taric_commodity_code",
    type: "string",
    label: "TARIC / Commodity Code",
    default: "",
    section: "Producer & Facility Identification",
  },

  // Compliance & Other Union Law
  {
    field: "compliance_documentation",
    type: "string",
    label: "Compliance Documentation",
    default: "",
    section: "Compliance & Other Union Law",
  },
  {
    field: "user_facing_information",
    type: "string",
    label: "User-Facing Information",
    default: "",
    section: "Compliance & Other Union Law",
  },
  {
    field: "data_quality",
    type: "string",
    label: "Data Quality",
    default: "",
    section: "Compliance & Other Union Law",
  },
  {
    field: "access_traceability",
    type: "string",
    label: "Access & Traceability",
    default: "",
    section: "Compliance & Other Union Law",
  },
  {
    field: "interoperability",
    type: "string",
    label: "Interoperability",
    default: "",
    section: "Compliance & Other Union Law",
  },

  // DPP System — Access, Governance & Registry
  {
    field: "access_rights",
    type: "string",
    label: "Access Rights",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "data_governance",
    type: "string",
    label: "Data Governance",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "digital_instructions",
    type: "string",
    label: "Digital Instructions",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "instructions_host",
    type: "string",
    label: "Instructions Host",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "granularity",
    type: "string",
    label: "Granularity",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "traceability_unit",
    type: "string",
    label: "Traceability Unit",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "eu_dpp_registry_id",
    type: "string",
    label: "EU DPP Registry ID",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },
  {
    field: "dpp_web_portal",
    type: "string",
    label: "DPP Web Portal",
    default: "",
    section: "DPP System — Access, Governance & Registry",
  },

  // Data Carrier
  {
    field: "carrier_type",
    type: "string",
    label: "Carrier Type",
    default: "",
    section: "Data Carrier",
  },
  {
    field: "layout_positioning",
    type: "string",
    label: "Layout & Positioning",
    default: "",
    section: "Data Carrier",
  },
  {
    field: "manner_of_availability",
    type: "string",
    label: "Manner Of Availability",
    default: "",
    section: "Data Carrier",
  },
  {
    field: "persistent_link_upi",
    type: "string",
    label: "Persistent Link (UPI)",
    default: "",
    section: "Data Carrier",
  },
  {
    field: "physical_presence",
    type: "string",
    label: "Physical Presence",
    default: "",
    section: "Data Carrier",
  },

  // Hosting
  {
    field: "hosting_platform",
    type: "string",
    label: "Platform",
    default: "",
    section: "Hosting",
  },
  {
    field: "hosting_registry",
    type: "string",
    label: "Registry",
    default: "",
    section: "Hosting",
  },
  {
    field: "hosting_registry_id",
    type: "string",
    label: "Registry ID",
    default: "",
    section: "Hosting",
  },
  {
    field: "hosting_portal",
    type: "string",
    label: "Portal",
    default: "",
    section: "Hosting",
  },
];

// dpp_format is shared verbatim across Product/Project/Building, but a few
// fields' keys ("product_id"/"product_name"/"product_category") were
// hardcoded to say "product" regardless of entity type — confusing when the
// value in dpp.product_name is actually a project's or building's name (the
// UI label already says "Project"/"Building" via renameLabel, but the
// underlying stored key didn't match). This returns a copy with just those
// fields' `field` key remapped to match the entity type; every other field
// is untouched. Product keeps the original array as-is — existing published
// Product passports already use these key names.
export const getDppFormat = (entityType = "product") => {
  if (entityType === "product") return dpp_format;
  const idField = entityType === "building" ? "building_id" : "project_id";
  const nameField = entityType === "building" ? "building_name" : "project_name";
  const categoryField = entityType === "building" ? "building_category" : "project_category";
  return dpp_format.map((f) => {
    if (f.field === "product_id") return { ...f, field: idField };
    if (f.field === "product_name") return { ...f, field: nameField };
    if (f.field === "product_category") return { ...f, field: categoryField };
    return f;
  });
};
